import {Game} from "../Game";
import {GameUtils} from "../utils/GameUtils";
import {gsap} from "gsap";
import {FireFrameAnimName} from "../enums/Enum";

export class FireFrame extends PIXI.spine.Spine {
    private _reelId: number;
    private _rowId: number;

    constructor(reelId: number, rowId: number) {
        super(Game.assetLoader.getSpineAsset("fireFrame"));
        this._reelId = reelId;
        this._rowId = rowId;
        this.init();
    }

    public play(size: FireFrameAnimName): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            this.setPivot(size);
            this.alpha = 1;
            this.visible = true;
        });
        tl.add(GameUtils.createTimelineForAnimation(this, 0, size + "start", false));
        tl.add(() => {
            this.state.setAnimation(0, size + "loop", true);
            this.autoUpdate = true;
        })
        return tl;
    }

    public playLoop(size: FireFrameAnimName): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            this.setPivot(size);
            this.alpha = 1;
            this.visible = true;
            this.state.setAnimation(0, size + "loop", true);
            this.autoUpdate = true;
        });
        return tl;
    }

    public stop(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.to(this, {duration: 0.1, alpha: 0});
        tl.add(() => {
            this.state.clearTracks();
            this.state.setEmptyAnimations(0);
            this.visible = false;
        });
        return tl;
    }

    private setPivot(size: FireFrameAnimName): void {
        if (size === FireFrameAnimName.SYMBOL_X2) {
            this.pivot.y = 99;
        } else if (size === FireFrameAnimName.SYMBOL_X2_HALF) {
            this.pivot.y = -45;
        } else {
            this.pivot.y = 0;
        }
    }

    private init(): void {
        this.name = "FireFrame_" + this._reelId + "_" + this._rowId;
        const pos: PIXI.Point = GameUtils.getSymbolPos(this._reelId, this._rowId);
        this.position.set(pos.x + 8, pos.y - 4);
        this.state.setAnimation(0, "1x1_start", false).timeScale = 100;
        this.visible = false;
    }
}